parasails.registerPage('vote', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    // GPS State
    isCheckingLocation: false,
    locationError: null,
    isWithinRange: false,
    currentDistance: null, // Allowed radius in meters
    transitionSettings: {
      folder: '/images/housepride/transition_webp/',
      prefix: 'transition-sp_',   // e.g. 'frame_' for frame_01.webp
      extension: '.webp',
      frameCount: 59,     // How many images are there?
      fps: 30,            // Speed of animation
      padZeros: 5         // e.g. 3 for '001', 2 for '01'
    },
    // Internal State
    transitionImages: [], // Holds the preloaded Image objects
    isTransitioning: false,
    areImagesLoaded: false,
    houses: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    selectedHouse: null,
    syncing: false,
    // Button States
    isVotePressed: false,
    isDownloadPressed: false,
    isApplyPressed: false,
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function () {
    // Polyfill `self` for libraries that expect it.
    // This should be one of the very first things your client-side JS runs.
    if (typeof self === 'undefined' && typeof window !== 'undefined') {
      var self = window;
    }

    // if (this.hasVoted === true) {
    //   this.selectedHouse = this.votedHouse;
    //   this.isCheckingLocation = false;
    //   this.isWithinRange = true;
    // } else {
    //   this.preloadTransitionImages();
    //   //GPS logic...
    //   if (this.gpsinfo.gpsEnabled == true) {
    //     this.checkLocation();
    //   } else {
    //     this.isCheckingLocation = false;
    //     this.isWithinRange = true;
    //   }
    // }

    this.preloadTransitionImages();

    if (this.gpsinfo.gpsEnabled == true) {
        this.checkLocation();
      } else {
        this.isCheckingLocation = false;
        this.isWithinRange = true;
      }
  },
  mounted: async function () {
    //…
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    selectHouse: function (houseName) {
      this.selectedHouse = houseName;
    },
    submitvote: async function () {
      if (!this.isWithinRange || this.selectedHouse == null) return;
      const deviceId = await this.getOrSetDeviceId();
      // sails.sockets.blast(prideEntry.eventId, {eventType: 'pridevote', urlslug: urlslug, selectedhouse: this.selectedHouse});
      io.socket.post('/hpvote', { eventid: this.prideEntry.eventId, urlslug: this.urlslug, selectedhouse: this.selectedHouse, deviceId: deviceId });
      await this.playTransition(() => {
        // This runs exactly when the screen is covered
        this.votedHouse = this.selectedHouse;
        this.hasVoted = true;
        window.scrollTo(0, 0); // Ensure the new page starts at the top
      });
    },
    goToApplyPage: function () {
      //TODO: Add the required GET request to the third party page...
    },
    downloadGift: function () {
      //TODO: Add the required code to initiate the download of the difigital gift...

      //:href="'/images/housepride/wallpaper/' + (votedHouse ? votedHouse.toLowerCase() : 'gryffindor') + '.jpg'"
      const wallpaperUrl = `/images/housepride/wallpaper/${this.votedHouse.toLowerCase()}.jpg`;

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = wallpaperUrl;
      
      // The 'download' attribute suggests a filename to the browser
      // and instructs it to download rather than navigate.
      link.download = `house-pride-${this.votedHouse}.jpg`; 
      
      // Open in new tab just in case (optional if using 'download')
      link.target = '_blank'; 

      // Trigger the click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getOrSetDeviceId: async function () {
      const STORAGE_KEY = 'housepride_deviceId';
      let deviceId = null;

      // 1. Try to get the ID from localStorage first.
      try {
        deviceId = localStorage.getItem(STORAGE_KEY);
        if (deviceId) {
          // Ensure the cookie is also set, in case it was cleared.
          document.cookie = `${STORAGE_KEY}=${deviceId}; path=/; max-age=31536000`; // 1 year
          return deviceId;
        }
      } catch (e) {
        console.warn('localStorage is not available.');
      }

      // 2. If not in localStorage, try to get it from the cookie.
      const cookieMatch = document.cookie.match(new RegExp(`(^| )${STORAGE_KEY}=([^;]+)`));
      if (cookieMatch) {
        deviceId = cookieMatch[2];
        // Sync it back to localStorage for faster access next time.
        try {
          localStorage.setItem(STORAGE_KEY, deviceId);
        } catch (e) { /* localStorage not available */ }
        return deviceId;
      }

      // 3. If it exists in neither, generate a new one.
      // We'll use a simple but effective random string generator.
      // This avoids needing a full library like nanoid on the client.
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        deviceId = result.visitorId; // This is the fingerprint hash (e.g., a4b1b3f2a8f8b1b3)
      } catch (error) {
        console.log("using fallback for deviceId");
        deviceId = 'hp_' + Date.now().toString(36) + Math.random().toString(36).substring(2);
      }

      // 4. Save the new ID to both localStorage and the cookie.
      try {
        localStorage.setItem(STORAGE_KEY, deviceId);
      } catch (e) { /* localStorage not available */ }
      document.cookie = `${STORAGE_KEY}=${deviceId}; path=/; max-age=31536000`; // 1 year

      return deviceId;
    },
    checkLocation: function () {
      this.isCheckingLocation = true;
      this.locationError = null;

      if (!navigator.geolocation) {
        this.locationError = 'unavailable';
        this.isCheckingLocation = false;
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Success
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;

          const distance = this.calculateDistance(userLat, userLng, this.gpsinfo.targetLatitude, this.gpsinfo.targetLongitude);
          console.log("Distance to target:", distance, "meters");

          this.currentDistance = Math.round(distance); // Round for display
          this.isWithinRange = distance <= this.gpsinfo.radius;
          this.isCheckingLocation = false;
        },
        (error) => {
          // Error handling
          console.warn('GPS Error:', error);
          if (error.code === error.PERMISSION_DENIED) {
            this.locationError = 'denied';
          } else {
            this.locationError = 'unavailable';
          }
          this.isCheckingLocation = false;
          this.isWithinRange = false; // Fail safe
        },
        {
          enableHighAccuracy: true, // Use GPS if available
          timeout: 10000,           // Wait up to 10s
          maximumAge: 0             // Do not use cached position
        }
      );
    },
    calculateDistance: function (lat1, lon1, lat2, lon2) {
      const R = 6371e3; // Earth radius in meters
      const φ1 = lat1 * Math.PI / 180;
      const φ2 = lat2 * Math.PI / 180;
      const Δφ = (lat2 - lat1) * Math.PI / 180;
      const Δλ = (lon2 - lon1) * Math.PI / 180;

      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c;
    },
    getVoteButtonSrc: function () {
      if (!this.selectedHouse) {
        return '/images/housepride/confirm_off.jpg';
      }
      if (this.isVotePressed) {
        return '/images/housepride/confirm_tap.jpg';
      }
      return '/images/housepride/confirm_on.jpg';
    },
    preloadTransitionImages: function () {
      let loadedCount = 0;
      const s = this.transitionSettings;

      for (let i = 0; i < s.frameCount; i++) {
        const img = new Image();

        // Handle zero padding (e.g. 1 -> '001')
        // Note: Assuming frames start at 0 or 1. Adjust 'i' or 'i+1' as needed.
        const numStr = (i).toString().padStart(s.padZeros, '0');

        img.src = `${s.folder}${s.prefix}${numStr}${s.extension}`;

        img.onload = () => {
          loadedCount++;
          if (loadedCount === s.frameCount) {
            this.areImagesLoaded = true;
            console.log('Transition animation preloaded.');
          }
        };

        // Store it in the array at the correct index
        this.transitionImages[i] = img;
      }
    },
    playTransition: function (midpointCallback) {
      return new Promise((resolve) => {
        if (!this.areImagesLoaded) {
          console.warn('Images not fully loaded, skipping animation.');
          if (midpointCallback) midpointCallback(); // Ensure state switches even if anim fails
          resolve();
          return;
        }

        this.isTransitioning = true;
        const canvas = this.$refs.transitionCanvas;
        const ctx = canvas.getContext('2d');

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        let frameIndex = 0;
        const totalFrames = this.transitionSettings.frameCount;

        // CALCULATE THE SWITCH POINT
        // We switch exactly halfway through. You can adjust this (e.g. totalFrames * 0.6)
        const switchFrame = Math.floor(totalFrames / 2);

        const fpsInterval = 1000 / this.transitionSettings.fps;
        let then = Date.now();

        const animate = () => {
          // Stop if we are done
          if (frameIndex >= totalFrames) {
            this.isTransitioning = false;
            resolve();
            return;
          }

          requestAnimationFrame(animate);

          const now = Date.now();
          const elapsed = now - then;

          if (elapsed > fpsInterval) {
            then = now - (elapsed % fpsInterval);

            // --- THE MAGIC MOMENT ---
            // If we hit the middle frame, trigger the UI switch
            if (frameIndex === switchFrame && midpointCallback) {
              midpointCallback();
            }
            // ------------------------

            const img = this.transitionImages[frameIndex];
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.drawImageProp(ctx, img, 0, 0, canvas.width, canvas.height);

            frameIndex++;
          }
        };

        animate();
      });
    },
    drawImageProp: function (ctx, img, x, y, w, h, offsetX, offsetY) {
      if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
      }

      offsetX = typeof offsetX === "number" ? offsetX : 0.5;
      offsetY = typeof offsetY === "number" ? offsetY : 0.5;

      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      var iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r,   // new prop. width
        nh = ih * r,   // new prop. height
        cx, cy, cw, ch, ar = 1;

      // decide which gap to fill    
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;

      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
    },
  }
});
